"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRamblerIdHelper = void 0;
const react_1 = require("react");
const loader_1 = require("./loader");
const useRamblerIdHelper = () => {
    const [ramblerIdHelper, setRamblerIdHelper] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!ramblerIdHelper) {
            (0, loader_1.getRamblerIdHelper)().then(setRamblerIdHelper);
        }
    }, []);
    return ramblerIdHelper;
};
exports.useRamblerIdHelper = useRamblerIdHelper;
//# sourceMappingURL=hooks.js.map